import Vue from "vue";
import axios from "axios";
import {reactive, toRefs, computed, provide, inject} from "@vue/composition-api";
import {updateListState} from "../store_helpers";
import {getFormattedProductFieldLabel} from "@/helpers/helpers";

export const state = reactive({
    map: new Map(),
    list: []
});

export const actions = {
    fetchAccountProductFields(account_id, params = null) {
        return new Promise(function (resolve, reject) {
            axios
                .get(Vue.config.url_prefix + "/api/a/{0}/product_fields/".format(account_id), {params: params})
                .then(function (resp) {
                    state.map = new Map(resp.data.map(i => [i.id, i]));
                    state.list = resp.data;
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    saveProductField(data) {
        return new Promise(function (resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/a/{0}/product_fields/".format(data.account_id), data)
                .then(function (resp) {
                    updateListState(resp.data.id, resp.data, state.list, "id", true);
                    resolve();
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    archiveProductField(data) {
        return new Promise(function (resolve, reject) {
            axios
                .patch(Vue.config.url_prefix + "/api/a/{0}/product_fields/archive".format(data.account_id), data)
                .then(function (resp) {
                    // we are archiving
                    updateListState(resp.data.id, resp.data, state.list, "id", true);
                    // updateListState(id, null, state.list);
                    resolve();
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
};

export const getters = {
    product_fields: computed(() => state.list),
    mapped_product_fields: computed(() => {
        return state.list.map(pf => {
            let product_field = pf
            product_field.name = getFormattedProductFieldLabel(pf)
            return product_field;
        });
    }),
    vats: computed(() => getters.mapped_product_fields.value.filter(pf => pf.type === "vat")),

    articles: computed(() => getters.mapped_product_fields.value.filter(pf => pf.type === "article")),

    resources: computed(() => getters.mapped_product_fields.value.filter(pf => pf.type === "resource")),
    billing_projects: computed(() => getters.mapped_product_fields.value.filter(pf => pf.type === "billing_project")),
    cost_centers: computed(() => getters.mapped_product_fields.value.filter(pf => pf.type === "cost_center")),

    units: computed(() => getters.mapped_product_fields.value.filter(pf => pf.type === "unit")),
    bank_accounts: computed(() => getters.mapped_product_fields.value.filter(pf => pf.type === "bank_account")),

    product_fields_by_type: type => computed(() => state.list.filter(pf => pf.type === type)),

    get_account_articles: account_id => computed(() => getters.articles.value.filter(pf => (pf.account_id === account_id))),
    get_account_resources: account_id => computed(() => getters.resources.value.filter(pf => (pf.account_id === account_id))),
    get_account_billing_projects: account_id => computed(() => getters.billing_projects.value.filter(pf => (pf.account_id === account_id))),
    get_account_cost_centers: account_id => computed(() => getters.cost_centers.value.filter(pf => (pf.account_id === account_id))),

    get_account_units: account_id => computed(() => getters.units.value.filter(pf => (pf.account_id === account_id))),

    format_product_field: pf => {
        let ret_str_list = [];
        if (pf.code) ret_str_list.push(pf.code);
        if (pf.label) ret_str_list.push(pf.label);
        if (pf.value) ret_str_list.push("(" + pf.value + ")");
        return ret_str_list.join(" ");
    },
};

export const key = Symbol("ProductFieldModule");

export const provideProductField = () => {
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });
};

export default () => inject(key);
